import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';// Ajuste o caminho do seu client do supabase

export default function VisitasContent() {
  const [totalVisits, setTotalVisits] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVisits = async () => {
      try {
        const { data, error } = await supabase
          .from('site_visits')
          .select('total_visits')
          .single();
        
        if (data) {
          setTotalVisits(data.total_visits || 0);
        }
      } catch (err) {
        console.error("Erro ao buscar visitas:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchVisits();
  }, []);

  return (
    <div style={{ color: '#fff', padding: '30px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <h2 style={{ fontSize: '22px', fontWeight: 'bold', margin: 0 }}>📊 Estatísticas de Acessos</h2>
      <p style={{ color: '#888', fontSize: '14px', margin: 0 }}>
        Acompanhe abaixo o total de visualizações e pessoas que acessaram o domínio do Doisplay.
      </p>

      <div style={{
        backgroundColor: '#141414',
        border: '1px solid #222',
        borderRadius: '12px',
        padding: '30px',
        maxWidth: '300px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.5)'
      }}>
        <span style={{ fontSize: '14px', color: '#aaa', textTransform: 'uppercase', letterSpacing: '1px' }}>
          Total de Acessos
        </span>
        <span style={{ fontSize: '36px', fontWeight: 'bold', color: '#E50914' }}>
          {loading ? '...' : totalVisits}
        </span>
      </div>
    </div>
  );
}